/* eslint-disable arrow-body-style */
import _ from 'underscore';

export const getShortHeadlineStyles = ({ styleOverrides }) => () => {
  return {
    shortHeadline: _.extend({
      fontWeight: 200,
      paddingBottom: '5px',
    }, styleOverrides.shortHeadline),
  };
};
